import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../../features/auth/auth.service';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();
  const isHealthSuiteApi =
    req.url === environment.apiUrl || req.url.startsWith(`${environment.apiUrl}/`);

  // El token de la sesión solo debe viajar a la API principal.
  // Servicios externos, como el validador, manejan su autenticación por separado.
  if (isHealthSuiteApi && token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  // Interceptamos errores 401
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Un 401 de un servicio externo no debe cerrar la sesión del backoffice.
      if (isHealthSuiteApi && error.status === 401) {
        authService.logout();
      }
      return throwError(() => error);
    }),
  );
};
